export const PERIMETERS_ROUTE_NAME = 'perimeters_scores'
